import {
  FacilityUsageFacilityType,
  FacilityUsageSlotSearchTimeType,
  FacilityUsageSlotSearchType,
  FacilityUsageStatus,
} from "src/api/contract/facility-usage-slot-types";

/**
 * 공용공간 정산 화면 UI 옵션/라벨 정의
 */

// 정산 상태 옵션 (멀티 셀렉트)
export const facilityUsageStatusOptions: Array<{ label: string; value: FacilityUsageStatus | "" }> = [
  { label: "전체", value: "" },
  { label: "예약", value: "SCHEDULED" },
  { label: "확정", value: "CONFIRMED" },
  { label: "취소", value: "CANCELLED" },
];

// 정산 상태 → 라벨
export const facilityUsageStatusLabel: Record<FacilityUsageStatus, string> = {
  SCHEDULED: "예약",
  CONFIRMED: "확정",
  CANCELLED: "취소",
};

// 정산 상태 → chip 색상 클래스 (예약 상태 컬럼과 동일한 status 색상 사용: A 파랑, B 초록, D 회색)
export const facilityUsageStatusChipClass: Record<FacilityUsageStatus, string> = {
  SCHEDULED: "status A",
  CONFIRMED: "status B",
  CANCELLED: "status D",
};

// 공용공간 유형 → 라벨
export const facilityTypeLabel: Record<FacilityUsageFacilityType, string> = {
  MEETING_ROOM: "회의실",
  DESK: "좌석",
  REFRESH_ROOM: "휴게 공간",
};

// 기간 옵션
export const settlementSearchTimeTypeOptions: Array<{ label: string; value: FacilityUsageSlotSearchTimeType }> = [
  { label: "소진기간", value: "USAGE_PERIOD" },
  { label: "예약기간", value: "RESERVATION_PERIOD" },
];

// 텍스트 검색 옵션
export const settlementSearchTypeOptions: Array<{ label: string; value: FacilityUsageSlotSearchType }> = [
  { label: "전체", value: "all" },
  { label: "정산 ID", value: "usageSlotId" },
  { label: "예약 ID", value: "reservationId" },
  { label: "예약명", value: "reservationName" },
  { label: "소속 회사", value: "organizationName" },
];
